import { Box, Card, Image, Paper, ScrollArea, Space, Text, Title } from '@mantine/core'
import React, { memo, useContext, useEffect, useState } from 'react'
import classes from './Categorytype.module.css'
import { FaChevronRight } from 'react-icons/fa6'
import useFetch from '../../../../Customhooks/useFetch'
import { baseUrl } from '../../../../Constants/constant'
import { useDisclosure } from '@mantine/hooks'
import ProductSlection from './ProductSelection/ProductSlection.component'
import MultiStepper from './MultiComponentStepper/MultiStepper.component'
import { authContext } from '../../../../context/AuthProvider.component'
// import { FaCheckCircle } from "react-icons/fa";

const CategoryType = ({ verticalid }: any) => {
    const token = localStorage.getItem("token");
    const [categoryId, setCategoryId] = useState<number>()
    const [categoryName, setCategoryName] = useState<any>()
    const [opened, { open, close }] = useDisclosure(false);
    const { computeId, setError } = useContext<any>(authContext);
    const updatedUrl = baseUrl.replace("/api/", "");

    const {
        data: getfieldData,
        loading: getfieldLoading,
        error: getfieldError,
        fetchData: getfield,
    } = useFetch({
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token || "",
        },
    });

    useEffect(() => {
        getfield(`${baseUrl}admin/categories?vertical_id=${verticalid}`);
        sessionStorage.setItem('selectedVerticalId', JSON.stringify(verticalid));
    }, [verticalid]);
    useEffect(() => {
        if (getfieldError) {
            setError(getfieldError?.message)
        }
    }, [getfieldError]);

    const handdleClickSubs = (id: number, name: string) => {
        open()
        setCategoryId(id)
        setCategoryName(name)
    }

    return (
        <>
            <Paper p={20} mt={15} style={{ border: '1px solid #00000026' }}>
                <Box className={classes.maindiv}>
                    {!computeId && <ScrollArea h={410} scrollbarSize={2} className={classes.cardsdiv}>
                        <Box>
                            <Title order={6}>
                                Select Sub-Category Type
                            </Title>
                        </Box>
                        <Space h="lg" />
                        {getfieldData?.data?.rows?.map((el: any, index: number) => (

                            <Card
                                shadow="xs"
                                padding="sm"
                                className={classes.card}
                                key={index}
                                mb={18}
                                onClick={() => handdleClickSubs(el.category_id, el.category_name)}

                            >
                                <Box style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                                    <Box className={classes.verticalslogo}>
                                        {el.category_icon === 'null' ? '' : <Image fit="contain" src={`${updatedUrl}${el.category_icon}`} alt="icon" />}
                                    </Box>
                                    <Text fw={400} size="lg" >
                                        {el.category_name}
                                    </Text></Box>
                                <Box pt={4}>
                                    <FaChevronRight />
                                </Box>
                            </Card>
                        ))}
                        <ProductSlection
                            isOpen={opened}
                            onClose={close}
                            categoryId={categoryId}
                            categoryName={categoryName}
                        />

                        <Space h="lg" />
                    </ScrollArea>}
                    <Box className={classes.SubCategorySection}>
                        <MultiStepper />
                    </Box>
                </Box>

            </Paper>
        </>
    )
}

export default memo(CategoryType)